import { jsx as _jsx } from "react/jsx-runtime";
import { dateMaskOptions } from "@/utils/masks";
import { useMaskito } from "@maskito/react";
import React from "react";
const MaskedInput = React.forwardRef((props, ref) => {
    const dateScheduleMask = useMaskito({ options: dateMaskOptions });
    const setRef = (node) => {
        dateScheduleMask(node);
        if (typeof ref === "function") {
            ref(node);
        }
        else if (ref && typeof ref === "object") {
            ref.current = node;
        }
    };
    return _jsx("input", { ref: setRef, ...props });
});
export default MaskedInput;
